import { z as e } from "zod";
import { ocPublic as t } from "../common/auth/procedure-builders.js";
import "../swagger/security.js";
import { SwaggerTags as a } from "../swagger/tags.js";
import { ReadinessResponseSchema as r, LivenessResponseSchema as o, HealthResponseSchema as s } from "./schemas.js";
const c = {
  app: {
    /**
     * @deprecated Use liveness endpoint instead
     * Legacy health check endpoint
     */
    health: t().route({
      method: "GET",
      path: "/health",
      summary: "Health check endpoint (legacy)",
      tags: [a.APP.name],
      deprecated: !0
    }).input(e.object({})).output(s).errors({}),
    /**
     * Liveness probe endpoint
     *
     * Returns 200 if the application is running.
     * Use for Kubernetes liveness probe - if this fails, pod should be restarted.
     *
     * No authentication required.
     */
    liveness: t().route({
      method: "GET",
      path: "/health/live",
      summary: "Liveness probe - checks if app is running",
      tags: [a.APP.name]
    }).input(e.object({})).output(o).errors({}),
    /**
     * Readiness probe endpoint
     *
     * Returns 200 if the application is ready to serve traffic.
     * Checks database connectivity.
     * Use for Kubernetes readiness probe - if this fails, pod won't receive traffic.
     *
     * No authentication required.
     */
    readiness: t().route({
      method: "GET",
      path: "/health/ready",
      summary: "Readiness probe - checks if app is ready (includes DB check)",
      tags: [a.APP.name]
    }).input(e.object({})).output(r).errors({})
  }
};
export {
  c as appContract
};
//# sourceMappingURL=contract.js.map
